<template>
  <v-card v-if="variant === 'opportunities'" class="loading-opportunities d-flex flex-column justify-start px-5">
    <div class="my-6 loading-header px-5">
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
    </div>
    <div class="loading-text">
      <v-skeleton-loader type="text" class="px-2"></v-skeleton-loader>
      <v-skeleton-loader type="text" class="px-2"></v-skeleton-loader>
    </div>
    <div class="py-4 loading-card">
      <v-skeleton-loader type="text" class="px-2"></v-skeleton-loader>
      <v-skeleton-loader type="text" class="px-2 pt-2"></v-skeleton-loader>
    </div>
    <div class="loading-footer mt-10">
      <v-skeleton-loader type="text" class="px-2"></v-skeleton-loader>
      <v-skeleton-loader type="text" class="px-2"></v-skeleton-loader>
    </div>
    <div class="clip-ticket d-flex justify-space-between align-center">
      <div class="left"></div>
      <div class="line"></div>
      <div class="right"></div>
    </div>
  </v-card>
  <v-card v-else-if="variant === 'more-info'" class="py-4">
    <div class="loading-more-info">
      <v-skeleton-loader type="text" class="px-4 more-info-first-child"></v-skeleton-loader>
      <v-skeleton-loader type="text" class="px-4 pt-1"></v-skeleton-loader>
      <v-skeleton-loader type="text" class="px-4 pt-2"></v-skeleton-loader>
    </div>
  </v-card>
  <v-card v-else class="py-4">
    <div class="loading-simple">
      <v-skeleton-loader type="text" class="px-4 simple-first-child"></v-skeleton-loader>
      <v-skeleton-loader type="text" class="px-4 pt-1"></v-skeleton-loader>
      <v-skeleton-loader type="text" class="px-4 pt-2"></v-skeleton-loader>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    variant: {
      type: String,
      validator: (value) => ['simple', 'more-info', 'opportunities'].includes(value),
      default: 'simple',
    },
  },
}
</script>

<style scoped lang="scss">
.loading-simple {
  width: 100%;
  .simple-first-child {
    width: 50%;
  }
  :nth-child(2) {
    width: 35%;
    height: 44px;
    :first-child {
      height: 100%;
    }
  }
  :nth-child(3) {
    width: 85%;
  }
}
.loading-more-info {
  width: 100%;
  height: 240px;
  .more-info-first-child {
    width: 50%;
  }
  :nth-child(2) {
    width: 80%;
  }
  :nth-child(3) {
    height: 70%;
    :first-child {
      height: 100%;
    }
  }
}
.loading-opportunities {
  height: 100% !important;

  .loading-text {
    :nth-child(2) {
      width: 90%;
    }
  }
  .loading-card {
    height: 40%;
    :first-child {
      height: 80%;
      .v-skeleton-loader__text {
        height: 100% !important;
      }
    }
    :nth-child(2) {
      height: 25%;
      width: 85%;
    }
  }
}

.clip-ticket {
  width: 103%;
  position: absolute;
  bottom: 20%;
  left: 0;
  margin-left: -1.5%;
  .line {
    width: 100%;
    height: 1px;
    background-image: repeating-linear-gradient(-34deg, $cinza-l70, $cinza-l70 7px, transparent 7px, transparent 17px, $cinza-l70 17px),
      repeating-linear-gradient(56deg, $cinza-l70, $cinza-l70 7px, transparent 7px, transparent 17px, $cinza-l70 17px),
      repeating-linear-gradient(146deg, $cinza-l70, $cinza-l70 7px, transparent 7px, transparent 17px, $cinza-l70 17px),
      repeating-linear-gradient(236deg, $cinza-l70, $cinza-l70 7px, transparent 7px, transparent 17px, $cinza-l70 17px);
    background-size: 2px 100%, 100% 2px, 2px 100%, 100% 2px;
    background-position: 0 0, 0 0, 100% 0, 0 100%;
    background-repeat: no-repeat;
  }
  .right {
    width: 20px;
    height: 20px;
    background-color: #f6f6f8;
    border-radius: 50%;
    box-shadow: inset 1px 0px 0px #aaaaaa;
  }

  .left {
    width: 20px;
    height: 20px;
    background-color: #f6f6f8;
    border-radius: 50%;
    box-shadow: inset -1px 0px 0px rgba(0, 0, 0, 0.16);
  }
}
::v-deep .v-skeleton-loader__avatar {
  background-color: $cinza-l80 !important;
}
::v-deep .v-skeleton-loader__text {
  height: 20px;
  background-color: $cinza-l80 !important;
}
</style>
